import React, { useEffect, useState } from 'react'
import styles from './SinglePage.module.css'
import { Avatar, Col, Row, Typography, Image, Divider, Spin, message, Button } from 'antd'
// import MultipleSlider from '../../Components/Multiple Slider/MultipleSlider';
import { AuthorCard1, AuthorCard2, ErrorPage, ImageItem, LinkItem, RecommendationCard, SinglePageTags, TextItem, UserActionsBar } from '../SmallComponents/SmallComponents';
// import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// import { fetchUserItems } from '../../Slices/UserItemsSlice';
import { useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import MultipleSlider from '../Multiple Slider/MultipleSlider';
import { fetchPublicItems, refreshCard, setPublicItemsError } from '../../Slices/PublicCollectionsDataSlice';
import EmptyData from '../EmptyData/EmptyData';
import { changeAdding, changeRemoving, removeLastWindowNHQ, setWindowNHQ } from '../../Slices/WindowNHQSlice';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';
import { useIsMount } from '../../Custom Hooks/useIsMount';
import { Helmet } from 'react-helmet';
import PageBackButton from '../PageBackButton/PageBackButton';
import parse from 'html-react-parser';
const { Text, Title, Paragraph } = Typography;

type Props = {}


const SinglePage = (props: Props) => {
  // const {id} = useParams();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const collectionData = useSelector((state: any) => state.publicCollectionsData?.items);
  const windowNHQ = useSelector((state: any) => state.windowNHQ?.data);
  const removing = useSelector((state: any) => state.windowNHQ?.removing)
  const adding = useSelector((state: any) => state.windowNHQ?.adding)
  const content = useSelector((state: any) => state.windowNHQ?.content)
  const { publicItemsError, publicItemsLoader } = useSelector((state: any) => state.publicCollectionsData)
  const navigationType = useNavigationType();
  const location = useLocation();

  useEffect(() => {
    //   console.log("hey" , collectionData)
  }, [collectionData])

  const { details, items, suggested_collections, author_collections } = collectionData ?? {};

  const handleBack = () => {
    navigate(-1);
  // dispatch(removeLastWindowNHQ());
  }

  useEffect(() => {
    if (navigationType === 'POP') {
      dispatch(removeLastWindowNHQ())
    }
    else if (navigationType === 'PUSH') {
    }
  }, [window.location.pathname])

  const antIcon = (
    <LoadingOutlined className={styles.customLoader} spin />
  );

  useEffect(() => {

    if (content?.length > 0) {
      let str = window.location.pathname.split('/')
      let collectionId = null;
      for (let ele of content) {
        // if (ele.slug === str[str.length - 1]) {
        collectionId = ele.id;
        break;
        // }
      }
      console.log(collectionId, 'WINDOW COLLECITON ID')
      if (collectionId) {
        dispatch(fetchPublicItems(collectionId))
        dispatch(changeRemoving('none'));
        dispatch(changeAdding('none'));
      }
    }
    else if (((typeof (window as any).NHQ?.current_id !== "undefined" && (window as any).NHQ?.current_id !== '' && (window as any).NHQ?.ccurrent_id !== null)) || process.env.REACT_APP_CURRENT_COLLECTION_ID) {
      dispatch(fetchPublicItems((window as any).NHQ?.current_id ?? process.env.REACT_APP_CURRENT_COLLECTION_ID))
      dispatch(setWindowNHQ({ id: (window as any).NHQ?.current_id, type: 'collection', slug: details?.slug }))
    } else {
      dispatch(setPublicItemsError(404))
      // message.error("Collection ID Not Found!")
    }

  }, [location.pathname, windowNHQ])

  useEffect(() => {
    console.log(details, 'details')
  }, [details])

  //   useEffect(()=>{
  //     console.log(details?.thumbnail)
  //   }, [details?.thumbnail])
  // useEffect(()=>{
  //     // dispatch(fetchUserItems(id));
  //     window.scrollTo({
  //         top: 0,
  //         left: 0,
  //         behavior: "smooth"
  //       }); // not working properly
  // }, [id])

  return (
   <>
       <Helmet>
    <title>{`${details?.title} | by ${details?.author?.username} | NotableHQ`}</title>
        <meta name="description" content={details?.description_text} />
        <meta name="theme-color" content="#008f68" />
      </Helmet>
      {publicItemsLoader ?
        <Col style={{ minHeight: "100vh" }}>
          <Spin
            indicator={antIcon}
            className={styles.spinner}
            spinning={true}
            fullscreen
          />
        </Col>
        : publicItemsError ?
          <ErrorPage button status={"collectionNotFound"} buttonText={"Back to collections"} subTitle /> :
          collectionData &&
          <Row className={styles.singlePageMain} gutter={[0, 5]} >
            <PageBackButton onClick={handleBack} />
            <Col span={24}>
              <Title level={1} className={styles.singlePageTitle} >{details?.title}</Title>

                <AuthorCard1 username={details?.author?.username} authorId={details?.author?.id} authorName={details?.author?.name} publishDate={details?.publish_date} authorImg={details?.author?.pic} />

                <UserActionsBar votes={details?.details?.votes} likes={details?.details?.likes} dislikes={details?.details?.dislikes} liked={details?.details?.liked} disliked={details?.details?.disliked} id={details?.id} bookmarked={details?.details?.bookmarked} />

    {
      details?.thumbnail &&
    <Image
    preview={false}
    width={'100%'}
    src={details?.thumbnail !== 'https://www.notablehq.com/wp-content/uploads/2024/02/image-not-found.png'  ? details?.thumbnail : undefined}
  />
    }
    <Paragraph style={{marginTop: "10px"}}>
                  {parse(details?.details?.description ?? '')}
    </Paragraph>
    </Col>
    
    <Divider className={styles.divider}  />


              {
                items?.length > 0 ?
                  items?.map((e: any) => (


                    e.type === 'text' ?
                      <>
                        <Col span={24} key={e.id}>
                          <TextItem title={e?.title} description={e?.description} />
                        </Col>
                        <Divider className={styles.divider} />
                      </>
                      : e.type === 'img' ?
                        <>
                          <Col span={24} key={e.id}>
                            <ImageItem title={e?.title} description={e?.description} url={e?.url !== '' ? e?.url : e?.file?.url} />
                          </Col>
                          <Divider className={styles.divider} />
                        </>

                        : e.type === 'url' ?
                          <>
                            <Col span={24} key={e.id}>
                              <LinkItem title={e?.title} description={e?.description} url={e?.url} />
                            </Col>
                            <Divider className={styles.divider} />
                          </>
                          : null

                  ))

                  :
                  <Row justify={"center"} align={'middle'} style={{ rowGap: "20px", minHeight: "200px", width: "100%" }} gutter={20}>
                    <EmptyData description={`Empty Collection`} buttonText={null} />
                  </Row>


              }
              <Col style={{ marginTop: "5px" }} span={24}>
                <SinglePageTags tags={details?.tags} />
              </Col>

              <Col span={24}>
                <UserActionsBar votes={details?.details?.votes} likes={details?.details?.likes} dislikes={details?.details?.dislikes} liked={details?.details?.liked} disliked={details?.details?.disliked} id={(window as any).NHQ?.current_id} bookmarked={details?.details?.bookmarked} />
              </Col>


              <Col span={24}>
                <AuthorCard2 authorId={details?.author?.id} username={details?.author?.username} authorName={details?.author?.name} authorImg={details?.author?.pic} authorBio={details?.author?.description} />
              </Col>

              <Col span={24}>
                <Title style={{ margin: "10px 0" }} level={5}>More From Author</Title>
                {
                  author_collections?.length > 0 ?

                    <MultipleSlider data={collectionData?.author_collections} />
                    :
                    <Row justify={"center"} align={'middle'} style={{ rowGap: "20px", minHeight: "200px", width: "100%" }} gutter={20}>
                      <EmptyData description={`No Collections`} buttonText={null} buttonOnClick={() => console.log("")} />
                    </Row>
                }
              </Col>

              <Divider />

              <Col span={24}>
                <Title style={{ margin: "0 0 10px 0" }} level={5}>Recommendations</Title>
                {
                  suggested_collections?.length > 0 ?
                    <Row gutter={[10, 30]}>

                      {suggested_collections?.map((e: any) => (
                        <RecommendationCard key={e?.id} id={e?.id} url={e?.url} title={e?.title} description={e?.details?.description} slug={e?.slug} featureImg={e?.thumbnail} authorName={e?.author?.name} authorImg={e?.author?.pic} publishDate={e?.publish_date} likes={e?.details?.likes} dislikes={e?.details?.dislikes} />
                      ))
                      }
                    </Row>
                    :
                    <Row justify={"center"} align={'middle'} style={{ rowGap: "20px", minHeight: "200px", width: "100%" }} gutter={20}>
                      <EmptyData description={`No Collections`} buttonText={null} buttonOnClick={() => console.log("")} />
                    </Row>
                }
              </Col>


          </Row>
      }
    </>
  )
}

export default SinglePage